"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnwrapLinkButton = void 0;
const slate_1 = require("slate");
const slate_react_1 = require("slate-react");
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const LinkOff_1 = __importDefault(require("@material-ui/icons/LinkOff"));
const is_mark_active_1 = require("../utils/is-mark-active");
// utils
const unwrap_link_1 = require("../utils/unwrap-link");
const button_styles_1 = require("./button-styles");
function UnwrapLinkButton() {
    const classes = (0, button_styles_1.useStyles)();
    const editor = (0, slate_react_1.useSlate)();
    const active = editor.selection &&
        !slate_1.Range.isCollapsed(editor.selection) &&
        (0, is_mark_active_1.isMarkActive)(editor, 'link');
    const disabled = !editor.selection ||
        slate_1.Range.isCollapsed(editor.selection) ||
        !(0, is_mark_active_1.isMarkActive)(editor, 'link');
    return (react_1.default.createElement("button", { disabled: disabled, onMouseDown: (event) => {
            event.preventDefault();
            (0, unwrap_link_1.unwrapLink)(editor);
        }, className: (0, clsx_1.default)(classes.button, {
            [classes.active]: active,
            [classes.disabled]: disabled,
        }) },
        react_1.default.createElement(LinkOff_1.default, { fontSize: "small" })));
}
exports.UnwrapLinkButton = UnwrapLinkButton;
//# sourceMappingURL=unwrap-link-button.js.map